import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LifeCycleDirective } from './life-cycle.directive';

@NgModule({
  declarations: [
    LifeCycleDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LifeCycleDirective
  ]
})
export class LifeCycleModule { }
